import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { Testimonials } from './components/Testimonials';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { PawBackground } from './components/PawBackground';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfUse } from './pages/TermsOfUse';
import { ContactUs } from './pages/ContactUs';
import { DeleteAccount } from './pages/DeleteAccount';
import { CreatorProgram } from './pages/CreatorProgram';
import { CreatorHelpCenter } from './pages/CreatorHelpCenter';
function HomePage() {
  return <>
      <main data-id="element-0" data-mp="28sutulzptvl7">
        <Hero data-id="element-1" data-mp="28sl5t3y8dyi5" />
        <HowItWorks data-id="element-2" data-mp="28s2zfehuu3wi" />
        <Features data-id="element-3" data-mp="23vktwcepa1j4" />
        <Testimonials data-id="element-4" data-mp="23w4clvc6cty7" />
        <CallToAction data-id="element-5" data-mp="23utby4e102bb" />
      </main>
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-6" data-mp="3iiwg8rrbto4t">
      <div className="min-h-screen bg-cream" data-id="element-7" data-mp="3ijftvw9y1qd1">
        <Navbar data-id="element-8" data-mp="3mlaxj7fckftz" />
        <Routes data-id="element-9" data-mp="3mkrchhuehbbq">
          <Route path="/" element={<HomePage data-id="element-11" data-mp="3mjg9vlcoy9m7" />} data-id="element-10" data-mp="3mk85gw6ag7ch" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-13" data-mp="3rdar8i4tqci4" />} data-id="element-12" data-mp="3rc9co3oln7vn" />
          <Route path="/terms-of-use" element={<TermsOfUse data-id="element-15" data-mp="5orh0l86u6j" />} data-id="element-14" data-mp="3rd189ei755lx" />
          <Route path="/contact-us" element={<ContactUs data-id="element-17" data-mp="56qxrrj5tst" />} data-id="element-16" data-mp="4wxfu7a14id" />
          <Route path="/delete-account" element={<DeleteAccount data-id="element-19" data-mp="2zm4xcjfp5b1a" />} data-id="element-18" data-mp="2zl3cjn8vpa6d" />
          <Route path="/creator" element={<CreatorProgram data-id="element-21" data-mp="33mf2xuzktzfm" />} data-id="element-20" data-mp="2zmwlj96ys6hj" />
          <Route path="/creator/help" element={<CreatorHelpCenter data-id="element-23" data-mp="33ori60dy9voz" />} data-id="element-22" data-mp="33nq6put0v76q" />
        </Routes>
        <Footer data-id="element-24" data-mp="38li8rhnds9on" />
      </div>
    </BrowserRouter>;
}